import React from "react";
import "./styles.css";

const ArrowDownIcon = ({ className }) => (
  <svg
    className={className}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M19 9l-7 7-7-7"
    ></path>
  </svg>
);

export const Hero = () => {
  const handleLearnMoreClick = (e) => {
    e.preventDefault();
    const whyWeMatterSection = document.getElementById("why-we-matter");
    if (whyWeMatterSection) {
      whyWeMatterSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="text-main-brown min-h-screen flex flex-col">
      {/* Main Content Area - centered */}
      <div className="flex-grow flex items-center justify-center px-5 lg:py-0 lg:px-14">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
          {/* Text Content */}
          <div className="w-full md:w-1/2 text-left mt-20">
            <h1 className="mb-8 text-header-1 font-bold"> {/* Have to add repeated font-bold because of other font overriding */}
              Early detection made simple.
            </h1>
            <p className="text-body text-xl mb-6">
              Upload a <span className="font-bold">clear photo</span> of a skin lesion, and our <span className="font-bold">AI-powered model </span> 
              will provide an estimate of the likelihood of <span className="font-bold">melanoma</span>, 
              helping you take the next step toward timely care.
            </p>
            <p className="lg:text-body-3 md:text-lg mb-8">
              <span className="font-bold">Disclaimer: </span>This tool is for educational purposes only. 
              It is not a substitute for professional medical advice, diagnosis, or treatment.
            </p>
            <div className="hidden md:flex items-center space-x-4">
              <a href="/scan" className="scan-button">
                Start Scanning
              </a>
            </div>
          </div>
          {/* Image */}
          <div className="lg:w-5/12 md:w-1/2 flex justify-center items-center relative mt-20">
            <img
              src="/assets/creative-young-adult-cropped.png"
              alt="Melanoma detection concept"
              className="w-60 md:w-full h-auto rounded-3xl"
            />
            <img src="assets/brown-circle.svg" alt="Brown Circle" className="absolute w-full h-full -rotate-6 mt-10" />
          </div>
        </div>
      </div>
      {/* Learn More - at the bottom of the section */}
      <div className="flex flex-col pb-24 text-center justify-center items-center">
        <a
          href="#why-we-matter"
          onClick={handleLearnMoreClick}
          className="text-main-brown text-lg md:text-2xl hover:text-orange-500 transition-colors flex flex-col items-center"
        >
          Learn More
          <ArrowDownIcon className="w-5 md:w-8 h-5 md:h-8 inline-block ml-2" />
        </a>
      </div>
    </section>
  );
};
